import { useCallback } from 'react';

import type { SessionStorageEntries } from '#src/lib/storage/sessionStorage.ts';
import { sessionStorage } from '#src/lib/storage/sessionStorage.ts';

export const useSessionStorage = <K extends keyof SessionStorageEntries>(
  key: K
): [
  SessionStorageEntries[K] | null,
  (value: SessionStorageEntries[K] | null) => void,
] => {
  const updateSessionStorage = useCallback(
    (v: SessionStorageEntries[K] | null) => sessionStorage.setItem(key, v),
    [key]
  );

  return [sessionStorage.getItem(key), updateSessionStorage];
};
